import { IPWAStatePersisted } from 'features/pwa/types'
import { IApplicationState } from 'setup/store'

type ReturnMigrationType = (state: IApplicationState) => {
  pwa: IPWAStatePersisted
}

export const pwaMigrations: Record<string, ReturnMigrationType> = {
  2: (state: IApplicationState) => ({
    pwa: {
      ...state.pwa,
      isNotificationShown: false,
    },
  }),
}
